<template>
  <div class="page-register">
    <div class="page-header">
      <h2>企业注册</h2>
    </div>
    <div class="page-body">
      <company v-if="userInfo && userInfo.userType === 1" type="modify" ref="company" @verify="onVerify"></company>
      <user ref="user" type="modify" @verify="onVerify"></user>
      <div class="mod-action">
        <a-button type="primary" size="large" :loading="loading" @click="onSubmit">提交</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchAgentInfo, modifyAgent, modifySubAgent } from '@/api/member'
import { verify } from '@/api/verify'
import Company from '@/pages/company-register/components/company'
import User from '@/pages/company-register/components/user'
import './index'

const verifyMap = {
  102: 'agentInfo.officeNo',
  100: 'userInfo.phone',
  101: 'userInfo.login',
  103: 'userInfo.email'
}

export default {
  data () {
    return {
      agentInfo: null,
      userInfo: null,
      loading: false
    }
  },
  mounted () {
    this.fetchAgent()
  },
  methods: {
    async fetchAgent () {
      try {
        const { agentUser, agentInfo } = await fetchAgentInfo({})

        this.agentInfo = agentInfo
        this.userInfo = agentUser

        this.$nextTick(() => {
          if (agentUser.userType === 1) {
            this.$refs.company.form.setFieldsValue({
              'registerAgentInfo.officeNo': agentInfo.officeNo,
              'registerAgentInfo.chiName': agentInfo.chiName,
              'registerAgentInfo.agentType': agentInfo.agentType,
              'registerAgentInfo.contactName': agentInfo.contactName,
              'registerAgentInfo.department': agentInfo.department,
              'registerAgentInfo.phoneNo': agentInfo.phoneNo
            })

            const city = []

            if (agentInfo.country) {
              city.push(agentInfo.country - 0)
            }

            if (agentInfo.province) {
              city.push(agentInfo.province - 0)
            }

            if (agentInfo.city) {
              city.push(agentInfo.city - 0)
            }

            if (city.length) {
              this.$refs.company.form.setFieldsValue({
                'registerAgentInfo.country': city
              })

              this.$refs.company.modifyInit(city)
            }
          }

          this.$refs.user.form.setFieldsValue({
            'registerAgentUserInfo.login': agentUser.login,
            'registerAgentUserInfo.chiSurname': agentUser.chiSurname,
            'registerAgentUserInfo.chiName': agentUser.chiName,
            'registerAgentUserInfo.phone': agentUser.phone,
            'registerAgentUserInfo.email': agentUser.email
          })
          this.$refs.user.modifyInit(agentUser.phone, agentUser.email)

          this.loading = false
        })
      } catch (err) {
        this.loading = false
        this.$message.error(err.message)
      }
    },
    onSubmit () {
      const { userInfo } = this

      if (userInfo.userType === 1) {
        this.$refs.company.form.validateFields((errors, companyValues) => {
          if (!errors) {
            this.submitUserForm(companyValues)
          }
        })
      } else {
        this.submitUserForm()
      }
    },
    submitUserForm (companyValues) {
      const { userInfo } = this

      this.$refs.user.form.validateFields((errors, userValues) => {
        if (!errors) {
          const { token, finalToken, code, phone, email } = this.$refs.user

          if (!phone && !email) {
            this.$error({
              content: '请输入联系方式！',
              centered: true
            })
            return
          }

          if (!code) {
            this.$error({
              content: `请输入${phone ? '手机' : '邮箱'}动态码！`,
              centered: true
            })
            return
          }

          if (!token) {
            this.$error({
              content: '请拖动滑块完成验证！',
              centered: true
            })
            return
          }

          if (!finalToken) {
            this.$error({
              content: '请点击获取动态码！',
              centered: true
            })
            return
          }

          const { registerAgentUserInfo } = userValues

          if (!phone) {
            delete registerAgentUserInfo.phone
          }

          if (!email) {
            delete registerAgentUserInfo.email
          }

          delete registerAgentUserInfo.confirmPassword

          if (userInfo.userType === 1) {
            const { registerAgentInfo } = companyValues

            if (registerAgentInfo.country) {
              const cities = registerAgentInfo.country.slice()
              const len = cities.length

              registerAgentInfo.country = cities[0]

              if (len > 1) {
                registerAgentInfo.province = cities[1]
              }

              if (len > 2) {
                registerAgentInfo.city = cities[2]
              }
            }

            this.modify({
              smsCode: code,
              token: finalToken,
              ...companyValues,
              ...userValues
            })
          } else {
            this.modify({
              smsCode: code,
              token: finalToken,
              ...registerAgentUserInfo
            })
          }
        }
      })
    },
    // 登录接口
    async modify (params) {
      const { userInfo } = this
      this.loading = true

      try {
        if (userInfo.userType === 1) {
          await modifyAgent(params)
        } else {
          await modifySubAgent(userInfo.uid, params)
        }

        this.$router.replace('/account')
      } catch (err) {
        this.loading = false
        this.$error({
          content: err.message,
          centered: true
        })
        this.$refs.user.$refs.verify.refresh()
        if (err.code.toString().includes(1000)) {
          this.$refs.user.errCode = err.code
        }
      }
    },
    async onVerify (value, type, cb) {
      const options = verifyMap[type].split('.')
      const oldValue = this[options[0]][options[1]]

      if (value === oldValue) {
        cb()
      } else {
        try {
          await verify({
            type,
            value
          })

          cb()
        } catch (err) {
          cb(err.message)
        }
      }
    }
  },
  components: {
    Company,
    User
  }
}
</script>
